
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import get from 'lodash/get';

const ParameterTextBox = ({
    id,
    onConfirm,
    onChangeValue,
    options,
    title,
    value
}) => {

    const handleChange = (evt, newValue) => {
        if (onChangeValue) {
            onChangeValue(id, newValue);
        }
    };

    const handleKeyDown = (evt) => {
        if ((onConfirm) && (evt.keyCode === 13)) {
            onConfirm();
        }
    }

    return (
        <TextField
            label={title}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            styles={get(options, 'TextBox.styles')}
            value={value}
        />
    );
}

export default ParameterTextBox;
